import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { FileTypeSinkAdapter } from 'app/model/adapters/activities/copysink/file-type.sink.adapter';
import { FileSystemSink } from 'app/model/pipeline/copysink/filesystem.copysink';
import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { CopySinkAdapter } from './copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FileSystemSink),
    asynchronous: true,
    adapts: {
        type: '*',
        copyBehavior: '*',
        maxConcurrentConnections: '*',
        structure: '*'
    }
})
export class FileSystemSinkAdapter extends CopySinkAdapter<FileSystemSink, Model.FileSystemSink> {
    protected override async _toResource(model: FileSystemSink): Promise<Model.FileSystemSink> {
        const result: Model.FileSystemSink = {
            type: 'FileSystemSink'
        };
        FileTypeSinkAdapter.toSinkResource(model, result);
        CopySinkAdapter.toCommonCopySinkResource(model, result, this.context);
        return result;
    }

    protected override async _toModel(resource: Model.FileSystemSink, owner: Activity): Promise<FileSystemSink> {
        const result = Owned.create<FileSystemSink>(Metamodel.modelFor(FileSystemSink), owner);
        FileTypeSinkAdapter.toSinkModel(resource, result);
        CopySinkAdapter.toCommonCopySinkModel(result, resource);
        return result;
    }
}
